export interface EmailSearch {
  draft?: string;
  message?: string;
}

export const validateEmailSearch = (
  search: Record<string, unknown>,
): EmailSearch => ({
  draft: typeof search.draft === "string" ? search.draft : undefined,
  message: typeof search.message === "string" ? search.message : undefined,
});
